import { env } from '@plvs/env'

import devLogger from './createLogger/createLogger.dev'
import prodLogger from './createLogger/createLogger.prod'

export const logger = env.IS_NODE_ENV_PRODUCTION ? prodLogger : devLogger
